import { render, staticRenderFns } from "./worknode.vue?vue&type=template&id=b5ed035c&"
import script from "./worknode.vue?vue&type=script&lang=js&"
export * from "./worknode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports